import Proxy from '../Proxy';

class RevenueProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('revenue', parameters);
  }
}

export default RevenueProxy;
